"use client";

import { c as _c } from "react/compiler-runtime";
import { setTimeOffset } from "@website/utils/time-sync-utils";
import { useEffect } from "react";
export const TimeSyncInitializer = t0 => {
  const $ = _c(3);
  const {
    serverNow
  } = t0;
  let t1;
  let t2;
  if ($[0] !== serverNow) {
    t1 = () => {
      const clientMs = Date.now();
      const diff = serverNow - clientMs;
      const offset = Math.abs(diff) > 600000 ? diff : 0;
      setTimeOffset(offset);
    };
    t2 = [serverNow];
    $[0] = serverNow;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
};